import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { industries } from '../mockData';
import { getIcon } from '../utils/icons';
import { ArrowRight } from 'lucide-react';

const IndustriesPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#003f6d] to-[#004a85] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Industries We Serve</h1>
          <div className="w-20 h-1 bg-[#d4af37] mb-6"></div>
          <p className="text-xl text-gray-200 max-w-3xl">
            QSC America provides ISO certification services across diverse industries, helping organizations achieve excellence in their specific sectors.
          </p>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {industries.map((industry, index) => {
              const Icon = getIcon(industry.icon);
              return (
                <Card
                  key={index}
                  className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                >
                  <CardContent className="p-8">
                    <div
                      className="w-16 h-16 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300"
                      style={{ backgroundColor: '#003f6d15' }}
                    >
                      <Icon className="w-8 h-8 text-[#003f6d]" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{industry.name}</h3>
                    <p className="text-gray-600 mb-6">{industry.description}</p>
                    <div className="space-y-2">
                      <p className="text-sm font-semibold text-gray-900">Relevant Standards:</p>
                      <div className="flex flex-wrap gap-2">
                        {industry.standards.map((standard, idx) => (
                          <span
                            key={idx}
                            className="text-xs font-medium px-3 py-1 bg-[#d4af37]/20 text-[#003f6d] rounded-full"
                          >
                            {standard}
                          </span>
                        ))}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#003f6d] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Don't See Your Industry Listed?
          </h2>
          <p className="text-xl text-gray-200 mb-8">
            We work with organizations across all sectors. Contact us to discuss your specific needs.
          </p>
          <Link to="/contact">
            <Button className="bg-[#d4af37] hover:bg-[#c49b2a] text-[#003f6d] font-semibold px-8 py-6 text-lg">
              Contact Us Today
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default IndustriesPage;
